export default {
  'da cheng international asset management co. ltd': '大成國際資產管理有限公司',
  'product': '產品',
  'analysis report': '分析報告',
  'resource': '資源',
  'me': '我',
  'login': '登錄',
  'logout': '登出',
  'username': '用戶名',
  'password': '密碼',
  '{1} is required': '請輸入{1}',
  'service statement': '服務條款',
  'user profile': '用戶信息',
  'accept': '同意',
  'reject': '不同意',
  'email': '郵箱',
  'contact person': '聯系人',
  'phone no': '聯系電話',
  'fax': '傳真號碼',
  'lanaguage': '首選語言',
  'simplified chinese': '簡體中文',
  'traditional chinese': '繁體中文',
  'english': '英文',
  'save': '保存',
  'the format of {1} is not correct': '{1}格式不正確',
  'position': '職位',
  'website': '官方主頁',
  'save successfully': '保存成功',
  'save failed': '無法保存',
  'documents': '用戶文件',
  'upload document': '上傳文件',
  'file type to upload': '上傳的文件類型',
  'type one': '文件類型1',
  'type two': '文件類型2',
  'type three': '文件類型3',
  'upload successfully': '上傳成功',
  'upload failed': '上傳失敗',
  'yyyy-mm-dd hh:mm:ss': 'YYYY年MM月DD日 HH:mm:ss',
  'last updated': '更新時間',
  'file name': '文件名',
  'status': '狀態',
  'uploaded': '已上傳',
  'accepted': '已接受',
  'rejected': '已拒絕',
  'home phone': '家庭電話',
  'mobile phone': '移動電話',
  'office phone': '辦公電話',
  'employment': '就業情況',
  'employed': '受雇',
  'self-employed': '自雇',
  'retired': '退休',
  'others': '其它',
  'remark': '備註',
  'country': '國家',
  'china': '中國',
  'hong kong': '中国香港特别行政区',
  'employer': '受雇機構',
  'products': '產品',
  'introduction': '概要',
  'performance': '基金表現',
  'please select product': '請選擇產品',
  'analysis reports': '分析報告',
  'download': '下載',
  'all products': '全部產品',
  'report name': '報告名',
  'report': '報告',
  'report type': '類型',
  'operation': '操作',
  'all types': '全部類型',
  'readed': '已讀',
  'unread': '未讀',
  'prev': '上壹頁',
  'next': '下壹頁',
  'search': '搜索',
  'language': '語言',
  'no data': '無數據',
  'upload': '上傳文件',
  'resources': '資源',
  'resource name': '資源名',
  'name': '名稱',
  'resource type': '資源類型',
  'user account is locked': '賬戶已被鎖住',
  'bad credentials': '用戶名或者密碼不正確',
  'period': '時間段',
  '1 month': '近1月',
  '3 months': '近3月',
  '1 year': '近1年',
  '3 years': '近3年',
  'all': '成立以來',
  'statistics': '統計數據',
  'indexes': '指數',
  'comparable indexes': '參照指數',
  'the page does not exist': '訪問的頁面不存在',
  'change password': '修改密碼',
  'old pass': '舊密碼',
  'new pass': '新密碼',
  'confirm': '確認密碼',
  'new password': '新密碼',
  'your password is expired, please change your password.': '您的密碼已經過期，請修改密碼',
  'change': '修改',
  'cancel': '取消',
  'length of new password must be 8 to 30': '新密碼必須8到30個字符',
  'new password and confirm password should be the same': '新密碼和確認密碼不壹致',
  'password update successfully': '密碼修改成功',
  'password update failed, please make sure the old password is correct': '密碼修改失敗，請確認舊密碼是否正確',
  '* please upload pdf, word, excel, png or jpg file. the maximum file size is 5mb.': '* 支持的文件類型是PDF, Word, Excel, PNG 或者JPGE，最大的能上傳的文件大小是 5MB',
  'activate account': '激活帳號',
  'the activate link is invalid or expired': '激活鏈接無效或者已過期',
  'account activate successfully': '帳號激活成功',
  'account activate failed. please make sure the link is valid': '帳號激活失敗，請確定激活鏈接是否有效',
  'forget password?': '忘記密碼?',
  'please enter the username': '請輸入賬號',
  'find password': '找回密碼',
  'find password failed. please make sure the username is correct': '無法找回密碼，請確定帳號是否正確',
  'the reset password link is sent to your email. please use the link to reset your password': '重設密碼鏈接已發到您的郵箱，請使用鏈接重設密碼',
  'reset password': '重設密碼',
  'the reset password link is invalid or expired': '重設密碼鏈接無效或者已過期',
  'password reset successfully': '密碼重設成功',
  'password reset failed. please make sure the link is valid': '密碼重設失敗，請確定重設鏈接是否有效',
  'new email': '新郵箱',
  'the format of email is not correct': '郵箱的格式不正確',
  'the activate link is sent to your new email address. please use the link to activate the new email': '新郵箱激活鏈接已發到您的新郵箱，請使用鏈接激活新郵箱',
  'change email': '修改郵箱',
  'change email failed, please make sure the email is correct': '無法修改郵箱，請確定郵箱是否正確',
  'ok': '確定',
  'activate new email': '激活新郵箱',
  'the new email is activated successfully.': '新郵箱激活成功',
  'activate new email failed. please make sure the link is valid.': '無法激活新郵箱，請確定鏈接是否有效',
  'download selected': '下載選中報告',
  'privacy': '隱私聲明',
  'dci asset management company limited., all rights reserved.': '大成國際資產管理有限公司版權所有',
  'dc fund': '大成國際',
  'by clicking "login", you agree to ': '按 [登錄] 即表示您同意 ',
  'our privacy statement': '隱私聲明',
  'id/passport no': '身分證或護照號碼',
  'if changing this field, please provide supporting documents': '如變更此欄，請聯系您的客戶經理並提供相關證明文件',
  'chinese name': '中文名',
  'english name': '英文名',
  'nationality': '國籍',
  'birthday': '出生日期',
  'country of birth': '出生國家',
  'residential address': '住宅地址',
  'business address': '辦公地址',
  'type': '類型',
  'disclaimer': '免責聲明',
  'disclaimer-content': '本文件由大成國際資產管理有限公司（「大成國際」）發佈，並未經香港證券及期貨事務監察委員會審核。投資涉及風險，投資者不應該僅根據本文件就做出投資決策。本文件內的任何建議或估計都是在一般化的基礎上做出的，投資者不應將其作為投資依據。大成國際對投資者因信賴本文件做出的投資決定而造成的損失不承擔任何責任。文件所提供的資訊並不含任何要約、招攬、或交易文件中提及的投資產品或服務。投資者應確定大成國際產品部人員已向閣下解釋與大成國際簽訂的投資管理協議是否適合閣下，及應參閱該投資管理協議內之相關風險披露聲明。專户投資份額的價值及收益可跌可升。過去表現或任何預測，未必代表專户將來或有可能達至的表現。大成國際或任何附屬機構對專户的投資回報並不承擔任何責任，亦不作出任何保證或擔保。大成國際盡力確保此文件所包含資訊準確和可靠，保證其準確性和可靠性。大成國際對於資訊不準確或資訊遺漏所造成的損失不承擔任何責任。未經大成國際的許可，不得抄襲、复制或提供此文件給第三者。',
  'disclaimer-data-content': '大成國際盡力確保相關統計數據準確和可靠，但並不保證其準確性、可靠性及完整性。大成國際對於資訊不准確或資訊遺漏所造成的損失不承擔任何責任。',
  'the email exists in the system. please use another email': '郵箱已經被占用，請使用其它郵箱',
  'net value': '基金凈值',
  'cumulative returns': '累計收益率',
  'annualized returns': '年化收益率',
  'annualized volatility': '年化波動率',
  'information ratio': '信息比率',
  'max drawdown': '最大回撤',
  "i've read the notice aboved": '我已閱讀上述通知',
  'company name': '機構名稱',
  'ci no': '公司註冊號',
  'registration area': '註冊地',
  'registration date': '註冊成立日期',
  'business type': '營業性質及目的',
  'registration address': '註冊地址',
  'please select file type': '請選擇文件類型',
  'dial code': '區號',
  '{1} and area code should both exist or not exist': '{1}和區號需同時存在或者同時為空',
  'this portal is for client only, for manager and compliance users, please use admin portal.': '該網站僅供客戶使用，如果你是客戶經理或合規用戶，請使用後臺管理網站。',
  'download net value': '下載基金凈值',
  'uploading the document, please wait': '文件上傳中，請稍等',
  'captcha': '驗證碼',
  'imageid is blank': '驗證碼無效',
  'code is blank': '驗證碼不能為空',
  'code is not matched': '驗證碼不正確',
  'code is expired': '驗證碼已過期',
  'position details': '持倉明細',
  'total position market value (Hong Kong Dollar)': '總持倉市值（港幣）',
  'total position cost (Hong Kong Dollar)': '總持倉成本（港幣）',
  'position fund count': '持倉基金數',
  'floating profit/loss (Hong Kong Dollar)': '持倉盈虧(港幣)',
  'cumulative return rate': '持倉收益率',
  'position date': '淨值日期',
  'fund name': '基金名稱',
  'base currency': '基礎貨幣',
  'household registration number': '賬戶號碼',
  'fund category': '份額類別',
  'fund category currency': '份額貨幣',
  'position quantity': '持倉數量',
  'cost price': '單位成本',
  'net asset value per unit': '基金單位净值',
  'position cost': '持倉成本(原幣)',
  'position cost (Hong Kong Dollar)': '持倉成本(港幣)',
  'position market value (Hong Kong Dollar)': '持倉市值(折算港幣)',
  'position market value': '持倉市值(原幣)',
  'converted market value': '折算市值（元）',
  'floating profit/loss': '持倉盈虧(原幣)',
  'profit/loss rate': '持倉收益率',
  'position ratio': '持倉占比',
  'account': '賬戶',
  'please select account': '請選擇賬戶',
  'export report': '導出報表',
  'query': '查詢',
  'total records': '共 {1} 條記錄',
  'first page': '首頁',
  'last page': '尾頁',
  'float profit/loss and return rate are calculated based on data since 2014.': '浮動盈虧及收益率基於2014年以來數據計算。',
  'position return rate tooltip': '當前賬戶下所有持倉基金的整體累計收益率，計算公式為：(總浮動盈虧 ÷ 總持倉成本) × 100%。',
  'cost price, floating profit/loss and return rate are calculated based on data since 2014.': '成本價、浮動盈虧及收益率基於2014年以來數據計算。',
  'holdings': '持倉',
  'transactions': '交易記錄',
  'transaction date': '交易日期',
  'transaction tranNo': '交易编号',
  'transaction type': '交易類型',
  'amount': '金額',
  'shares': '份額',
  'net value (txn)': '凈值',
  'fee': '費用',
  'transaction number': '交易編號',
  'buy': '買入',
  'sell': '賣出',
  'no holdings data': '暫無持倉數據',
  'no transactions data': '暫無交易記錄',
  'product information only for reference': '以下產品資訊僅供投資者參考，實際產品資訊以投資者與管理人簽署的相關協議及不時修訂為準。',
  'fund code': '基金代碼',
  'fund class': '基金類別',
  'total market value': '總市值',
  'data cutoff value': '數據截至',
  'yesterday return': '昨日收益',
  'holding profit/loss': '持有收益',
  'cumulative profit/loss': '累計盈虧',
  'performance trend': '業績走勢',
  '6 months': '近6月',
  'position': '持倉',
  'time range': '時間範圍',
  'start date': '開始日期',
  'end date': '結束日期'
}
